export interface CreateBibliographySearchContentListRequest {
  ids: number[]
}

export function CreateBibliographySearchContentListRequestToJSON(
  value: CreateBibliographySearchContentListRequest
): any {
  return {
    ids: value.ids.length > 0 ? value.ids : undefined
  }
}
